import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const ContentMediaSessionQuery: GraphQLTaggedNode = graphql`
	query ContentMediaSessionQuery($contentId: ID!) {
		contentMediaSession(contentId: $contentId) {
			token {
				value
				duration
				expiryDateTime
			}
			configuration {
				clientId
				fileStoreUrl
			}
		}
	}
`;
